module.exports = __webpack_public_path__ + "img/sensor-purple.e9a37324.svg";